import { breakpoint } from '@mnd-frontend/ui/shared/style-mixins/breakpoints';
import { SIZING_3, SPACING_3 } from '@mnd-frontend/ui/shared/tokens';
import Image from 'next/image';
import { memo } from 'react';
import styled from 'styled-components';
import type { TransformedCardProps } from './BlogCardGridModule';

const ImageContainer = styled.div`
    
`;

const StyledImageWrapper = styled.div`
    width: 100%;
    height: 12.5rem;
    position: relative;

    ${breakpoint.sm`
      height: 20rem;
    `}

    ${breakpoint.md`
      height: 15rem;
    `}

    img {
      object-fit: cover;
      object-position: center top;
    }
`;

const StyledLogo = styled.img`
    position: absolute;
    right: ${SPACING_3};
    bottom: ${SPACING_3};
    width: fit-content;
    max-height: ${SIZING_3};
`;

type BlogCardImageProps = {
  image: TransformedCardProps['image'];
  logo: TransformedCardProps['logo'];
};

const BlogCardImage = ({ image, logo }: BlogCardImageProps) => (
  <ImageContainer>
    {image.src && (
      <StyledImageWrapper>
        <Image src={image.src} alt={image.alt ?? ''} fill />
        {logo.src && <StyledLogo src={logo.src} alt={logo.alt ?? ''} loading="lazy" />}
      </StyledImageWrapper>
    )}
  </ImageContainer>
);

export default memo(BlogCardImage);
